import { Dictionary } from 'lodash'
import Message from '@/models/message'

export type FieldKey =
  | 'group'
  | 'qualifying'
  | 'group_type'
  | 'purposes'
  | 'accommodation'
  | 'dietary_preferences'
  | 'country'
  | 'country_list'
  | 'budget'
  | 'dates'
  | 'duration_and_dates'
  | 'url'

export class PlanATripMessage extends Message {
  isTyping: boolean

  constructor(args: ConstructorParameters<typeof Message>[0], isTyping?: boolean) {
    super(args)
    this.isTyping = typeof isTyping === 'boolean' ? isTyping : Boolean((args as any)?.isTyping)
  }
}
export interface PlanATripChatroom {
  id: number
  name: string
  product_id: string | null
  itinerary_request_id: number
  created_at: string
  lastMessage: PlanATripMessage
  aiActive: boolean
  tourheroes: string[] | null
  status: 'active' | 'inactive' | 'archived'
}

export interface SelectedDates {
  dateType: string
  duration: number
  durationUnit: string
  flexibleDates: Dictionary<string[]> | null
}

export interface PlanATripSelectionOption {
  actionType: string
  selection: string
  targetField: FieldKey
  text: string
  bodyText?: string
  icon?: string
  url?: string
}

export interface RecommendedCountryDetails {
  icon: string
  text: string
  selection: string
  actionType: string
  targetField: FieldKey
  timeToVisit: string
  highlightActivities: string[]
  recommendationSummary: string
  mostRecommended: boolean
  image: {
    url: string
  }
}
